// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_OK0","question":"styles_question__2VmmA","description":"styles_description__1PVqg"};